/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_WednesdayInputs */

const en_coach_day_wednesday = /** @type {(inputs: Coach_Day_WednesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wednesday`)
};

const de_coach_day_wednesday = /** @type {(inputs: Coach_Day_WednesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittwoch`)
};

/**
* | output |
* | --- |
* | "Wednesday" |
*
* @param {Coach_Day_WednesdayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_wednesday = /** @type {((inputs?: Coach_Day_WednesdayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_WednesdayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_wednesday(inputs)
	return de_coach_day_wednesday(inputs)
});